
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/how-to/mint-solana",
      function () {
        return require("private-next-pages/docs/how-to/mint-solana.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/how-to/mint-solana"])
      });
    }
  